"use client";

import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
export default function Hero() {
  const {
    ref: headlineRef,
    isVisible: headlineVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.3
  });
  const {
    ref: imageRef,
    isVisible: imageVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.2
  });
  const {
    ref: bodyRef,
    isVisible: bodyVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.2
  });
  return <section data-section-id="11714" id="hero" className="relative bg-background text-foreground py-24 md:py-32 overflow-hidden">
      <div className="mx-auto max-w-[1280px] px-5 sm:px-8 lg:px-20">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-16 items-center">
          <div ref={headlineRef} className="lg:col-span-5 order-2 lg:order-1 flex flex-col" style={{
          opacity: headlineVisible ? 1 : 0,
          transform: headlineVisible ? "translateY(0)" : "translateY(12px)",
          transition: "opacity 600ms cubic-bezier(0.22, 1, 0.36, 1), transform 600ms cubic-bezier(0.22, 1, 0.36, 1)"
        }}>
            <p className="font-default text-[0.8125rem] font-medium uppercase text-muted-foreground mb-8" style={{
            letterSpacing: "0.14em"
          }}>
              {"ΕΞΕΡΕΥΝΗΣΤΕ ΤΗΝ ΕΛΛΑΔΑ"}
            </p>

            <h1 className="font-serif text-foreground mb-8" style={{
            fontSize: "clamp(2.75rem, 6.4vw, 5.5rem)",
            fontWeight: 360,
            letterSpacing: "-0.02em",
            lineHeight: 0.98
          }}>
              {"Οι Απόλυτοι Ταξιδιωτικοί Οδηγοί"}
            </h1>

            <div ref={bodyRef} style={{
            opacity: bodyVisible ? 1 : 0,
            transform: bodyVisible ? "translateY(0)" : "translateY(12px)",
            transition: "opacity 600ms cubic-bezier(0.22, 1, 0.36, 1) 160ms, transform 600ms cubic-bezier(0.22, 1, 0.36, 1) 160ms"
          }}>
              <p className="font-serif text-foreground/90 mb-10 max-w-xl" style={{
              fontSize: "clamp(1.125rem, 1.4vw, 1.375rem)",
              fontWeight: 380,
              lineHeight: 1.55
            }}>
                {"Ανακαλύψτε κρυφά διαμάντια, ονειρικές παραλίες και τα καλύτερα μυστικά κάθε προορισμού. Βρείτε τον επόμενο σταθμό των διακοπών σας και κλείστε τη διαμονή σας στις καλύτερες τιμές στο HotelDeals.gr."}
              </p>

              <Button asChild size="lg" className="rounded-lg bg-primary text-primary-foreground hover:bg-primary/90 px-7 py-3.5 h-auto text-[0.9375rem] font-medium transition-colors duration-240 shadow-md" style={{
              letterSpacing: "0.02em"
            }}>
                <Link to="https://hoteldeals.vlmtravel.com/#/welcome">{"Βρείτε τον προορισμό σας"}</Link>
              </Button>
            </div>
          </div>

          <div ref={imageRef} className="lg:col-span-7 order-1 lg:order-2 relative" style={{
          opacity: imageVisible ? 1 : 0,
          transform: imageVisible ? "translateY(0)" : "translateY(12px)",
          transition: "opacity 600ms cubic-bezier(0.22, 1, 0.36, 1) 80ms, transform 600ms cubic-bezier(0.22, 1, 0.36, 1) 80ms"
        }}>
            <svg width="0" height="0" style={{
            position: "absolute"
          }} aria-hidden="true">
              <defs>
                <clipPath id="kiln-pebble-blob" clipPathUnits="objectBoundingBox">
                  <path d="M0.52,0.01 C0.71,0.02 0.87,0.09 0.95,0.24 C1.02,0.39 0.99,0.58 0.94,0.73 C0.88,0.88 0.74,0.97 0.57,0.99 C0.39,1.01 0.21,0.97 0.11,0.84 C0.01,0.71 -0.02,0.52 0.03,0.35 C0.08,0.18 0.21,0.06 0.36,0.02 C0.41,0.01 0.47,0.01 0.52,0.01 Z" />
                </clipPath>
              </defs>
            </svg>

            <div className="relative w-full" style={{
            aspectRatio: "5 / 6",
            maxHeight: "620px"
          }}>
              <div className="absolute inset-0" style={{
              clipPath: "url(#kiln-pebble-blob)",
              WebkitClipPath: "url(#kiln-pebble-blob)",
              animation: "kilnBlobMorph 6s ease-in-out infinite"
            }}>
                <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1698288/img/greek_island_travel_guide.png" data-wvc-srcset="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1698288/img/greek_island_travel_guide.png-wvc-srcset" data-wvc-sizes="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1698288/img/greek_island_travel_guide.png-wvc-sizes" alt="Εντυπωσιακή θέα σε ελληνικό νησί με κυκλαδίτικη αρχιτεκτονική και γαλάζια θάλασσα" className="w-full h-full object-cover" loading="lazy" decoding="async" />
              </div>
            </div>
          </div>
        </div>
      </div>

      <style>{`
        @keyframes kilnBlobMorph {
          0%, 100% {
            clip-path: url(#kiln-pebble-blob);
            border-radius: 62% 38% 54% 46% / 48% 56% 44% 52%;
          }
          50% {
            border-radius: 58% 42% 50% 50% / 52% 50% 50% 48%;
          }
        }
      `}</style>
    </section>;
}